import axios from "../../js/project-axios.js"

const list = (endDate, accountId, limit) => {
    return axios.get("/capital/entry/list", {
        params: {
            endDate,
            accountId,
            limit
        }
    });
};

const add = entry => {
    return axios.post("/capital/entry/add", entry);
};

const remove = entry => {
    return axios.post("/capital/entry/remove", entry);
};

export default {
    list,
    add,
    remove
};